import React from 'react'
import MenuItem from '@material-ui/core/MenuItem'
import Menu from '@material-ui/core/Menu'
import IconButton from '@material-ui/core/IconButton'
import AccountCircle from '@material-ui/icons/AccountCircle'
import Tooltip from '@material-ui/core/Tooltip'
import PropTypes from 'prop-types'
import { FormattedMessage } from 'react-intl'


class LoggedInWidget extends React.Component {
	constructor(props) {
		super(props)

		this.state = {
			menuAnchorElement: null
		}

		this.handleMenuOpen = this.handleMenuOpen.bind(this)
		this.handleLogout = this.handleLogout.bind(this)
		this.handleMenuClose = this.handleMenuClose.bind(this)
	}

	handleMenuClose() {
		this.setState({
			menuAnchorElement: null
		})
	}
	handleMenuOpen(e) {
		this.setState({
			menuAnchorElement: e.target
		})
	}

	handleLogout() {
		this.setState({
			menuAnchorElement: null
		})
		this.props.onLogout()
	}

	render() {
		return (
			<React.Fragment>
				<Tooltip title={<FormattedMessage id="app.login.loggedIn" values={{ name: this.props.username }} />} >
					<IconButton
						aria-haspopup="true"
						onClick={this.handleMenuOpen}
						color="inherit"
					>
						<AccountCircle />
					</IconButton>
				</Tooltip>
				<Menu
					id="menu-appbar"
					anchorEl={this.state.menuAnchorElement}
					anchorOrigin={{
						vertical: 'bottom',
						horizontal: 'right',
					}}
					transformOrigin={{
						vertical: 'top',
						horizontal: 'right',
					}}
					open={!!this.state.menuAnchorElement}
					onClose={this.handleMenuClose}
				>
					<MenuItem onClick={this.handleLogout}>
						<FormattedMessage id="app.login.logout" defaultMessage="Sign Out"/>
					</MenuItem>
				</Menu>
			</React.Fragment>
		)

	}
}

LoggedInWidget.propTypes = {
	onLogout: PropTypes.func,
	username: PropTypes.string
}


export default LoggedInWidget


// WEBPACK FOOTER //
// ./src/components/LoggedInWidget.js